module.exports = __webpack_public_path__ + "img/pay-check.459851fb.png";